import { Component, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export abstract class AbstractTable {
  readonly sort = viewChild.required(MatSort);

  abstract dataSource: MatTableDataSource<object>;
  dataSourceTotalLength: number = 0;
  dataSourceFilteredLength: number = 0;
  isLoading: boolean = false;
}
